import { Box } from "@mui/material";
import React from "react";

function StatBar(props) {
  const { bgcolor, completed } = props;
  const containerStyles = {
    height: 20,
    width: "100%",
    backgroundColor: "#e0e0de",
    borderRadius: 50,
  };

  const fillerStyles = {
    height: "100%",
    width: `${(completed * 100) / 255}%`,
    backgroundColor: bgcolor,
    borderRadius: "inherit",
    textAlign: "right",
  };

  const labelStyles = {
    padding: 5,
    color: "white",
    fontWeight: "bold",
  };

  return (
    <Box component="div" style={containerStyles}>
      <Box style={fillerStyles}>
        <span style={labelStyles}>{`${completed}`}</span>
      </Box>
    </Box>
  );
}

export default StatBar;
